import React, {  useState } from "react";
import { Row, Col, Button } from "reactstrap";
import { useMutationSetSprayCompleted, useQueryRetrieveSprayProducts } from "../../../services/stores";
import { SprayCampaign, SprayProduct, } from "../../../types";
import { formatDateDDMMM } from "../../../helpers/utils";
import {  ChevronDown, ChevronRight,  Key,  PlusCircle, Save, Slash, } from 'react-feather';
import { ProductCard } from "../../../components/ProductCard";
import LoadingInPogress from "../../../components/LoadingInProgress";
import { SprayHeaderCard } from "./SprayHeaderCard";

import "../../../assets/css/tanseeq.css";
import { EditSprayTankHeader } from "./EditSprayTankHeader";
import { toast } from "react-hot-toast";
import { ConfirmationModal } from "../../../components/ConfirmationModal";
export interface SprayCardProps {
  spray: SprayCampaign;
  dateFirstPlannedSpray: Date;
  onError?: (error: string) => void;
  index?: number;
  count?: number;
  acknowledgedSprayCount?: number;
}

const TRANSLATIONS = {
  SET_TREATMENT_AS_DONE: "Marquer comme terminé",
  CONFIRM_SET_TREATMENT_AS_DONE: "Voulez-vous vraiment clôturer ce traitement?",
  TREATMENT_CLOSED_SUCCESSFULLY: "Traitement clôturé avec succès",
  YES: "Oui",
  NO: "Non",
} as const;


export const SprayCard = ({ 
  spray,
  dateFirstPlannedSpray,
  onError,
  index = 0,
  count = 1,
  acknowledgedSprayCount = 0
}: SprayCardProps) => {
 
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [completionDate, setCompletionDate] = useState<Date>(new Date());

  const [isCreatingSprayTank, setIsCreatingSprayTank] = useState(false);

  const {
      data: savedSprayProducts,
      isLoading: isLoadingSavedSprayProducts,
      error: errorSavedSprayProducts } = useQueryRetrieveSprayProducts(spray.id);

  const persistSetSprayCompleted = useMutationSetSprayCompleted();
 
  const onSetComplete = () => {
        persistSetSprayCompleted.mutate(spray.id,
            {
                onSuccess: () => {
                    toast.success(TRANSLATIONS.TREATMENT_CLOSED_SUCCESSFULLY);
                },
                onError: (error) => {
                    toast.error(error.message);
                }
            }
        );
    }

  const onCreateNewSprayTank = () => {
    setIsCreatingSprayTank(true);
  }

  const onCloseSprayCampaign = () => {
      setShowConfirmModal(true);
  }

  const onSaveSprayTank = () => {
    setIsCreatingSprayTank(false);
  }

  const onCancelSprayTank = () => {
    setIsCreatingSprayTank(false);
  }

  if (errorSavedSprayProducts) {
    if (onError) {
      onError(errorSavedSprayProducts.message);
    }
    return null;
  }

  return (
      <div className="product-cards" style={{ marginTop: '10px' }}>


          <React.Fragment>
                {!spray.releasedForExecution &&
                    <div className="product-cards spray-warnings">
                      <Row  style={{marginTop: '10px', marginBottom: '10px' }}>
                        <Col xs = {1}>
                          <Slash className="text-danger" />
                        </Col>
                        <Col xs = {11} style={{paddingTop: '5px' }}>
                          <h6>Ce traitement n&apos;est pas encore validé pour la réalisation</h6>
                        </Col>
                      </Row>
                    </div>
                }

                {(new Date(spray.plannedStartDate) > dateFirstPlannedSpray) &&
                    <div className="product-cards spray-warnings">
                      <Row style={{marginTop: '10px', marginBottom: '10px' }}>
                        <Col xs = {1}>
                          <Slash className="text-danger" />
                        </Col>
                        <Col xs = {11} style={{paddingTop: '5px' }}>
                          <h6>Le traitement du {formatDateDDMMM(dateFirstPlannedSpray)} est encore en instance </h6>
                        </Col>
                      </Row>
                    </div>
                }
            
              <SprayHeaderCard spray={spray} />

              {isLoadingSavedSprayProducts && <LoadingInPogress message="Chargement des produits..." />}

              {savedSprayProducts?.map((product: SprayProduct, indexProduct: number) => (
                  <div key={ indexProduct}>
                    <ProductCard
                      key={ indexProduct} 
                      product={product} 
                    />
                  </div>
              ))}

          {spray.releasedForExecution && (
            <div className="text-center mt-3">
              <small className="text-muted fw-semibold">
                Citernes enregistrées: {acknowledgedSprayCount}
              </small>
            </div>
          )}
          
          {spray.releasedForExecution &&
              <div className="text-center mt-4">
                {!isCreatingSprayTank ? (
                  <div className="d-flex flex-column gap-2">
                    <Button
                      color="success"
                      onClick={onCreateNewSprayTank}
                      className="w-100 d-flex align-items-center justify-content-center"
                    >
                      <PlusCircle size={18} className="me-2" />
                      Enregistrer une/des citerne(s)
                    </Button>
                    {acknowledgedSprayCount > 0 && (
                      <Button
                        color="warning"
                        onClick={onCloseSprayCampaign}
                        className="w-100 d-flex align-items-center justify-content-center"
                      >
                        <Key size={18} className="me-2" />
                        Cloturer le traitement
                      </Button>
                    )}
                  </div>
                ) : (
                  <div className="d-flex flex-column gap-2">
                    <Button
                      color="success"
                      onClick={onCancelSprayTank}
                      className="w-100 d-flex align-items-center justify-content-center"
                    >
                      <Slash size={18} className="me-2" />
                      Annuler
                    </Button>
                    <Button
                      color="success"
                      onClick={onSaveSprayTank}
                      className="w-100 d-flex align-items-center justify-content-center"
                    >
                      <Save size={18} className="me-2" />
                      Sauvegarder
                    </Button>
                  </div>
                )}
              </div>
          }

          </React.Fragment>

          {spray &&
            <EditSprayTankHeader
              sprayPlanned={spray}
              showModal={isCreatingSprayTank}
              setShowModal={setIsCreatingSprayTank}
              completionDate={completionDate}
              setCompletionDate={setCompletionDate}
              products={savedSprayProducts || []}
            />}


            <ConfirmationModal
              show={showConfirmModal}
              title="Confirmation"
              message={TRANSLATIONS.CONFIRM_SET_TREATMENT_AS_DONE}
              yesLabel={TRANSLATIONS.YES}
              noLabel={TRANSLATIONS.NO}
              onYes={onSetComplete}
              onNo={() => setShowConfirmModal(false)}
            />
      </div>
  );
};
